<!-- 会员升级礼分享设置 -->
<template>
  <div class="share-settings">
    <div class="newsInfo">分享设置</div>
    <el-form-item label="小程序分享标题：" required>
      <el-input placeholder='请输入分享标题' type="text" style="width: 400px" show-word-limit v-model="formData.shareTitle"
        :maxlength="28" @input="onInput" :disabled="backgroundOpacity"></el-input>
    </el-form-item>
    <el-form-item label="小程序分享简介：" required>
      <el-input placeholder="请输入分享简介" type="text" style="width: 400px" show-word-limit v-model="formData.shareIntroduce"
        :maxlength="28" @input="onInput" :disabled="backgroundOpacity"></el-input>
    </el-form-item>
    <el-form-item label="小程序分享图片：" required>
      <div class="miniAppPic">
        <div class="top">
          <el-upload class="upload" action="/jd-hd-web/image/upload" :show-file-list="false"
            :before-upload="onBeforeUpload" :on-success="onUploadSuccess" :disabled="backgroundOpacity">
            <el-button :disabled="backgroundOpacity">自定义上传</el-button>
          </el-upload>
          <span v-if="!backgroundOpacity" class="reset" @click="onPicReset">重置</span>
          <span v-else class="noActive ml-8">重置</span>
        </div>
        <div class="bottom">
          <el-image class="elImg" :src="formData.sharePic" fit="contain">
            <div slot="error" class="image-slot">
              <i class="el-icon-plus"></i>
            </div>
          </el-image>
          <div class="tips1">
            <p>建议上传尺寸：200px * 200px</p>
            <p>图片大小：1MB以内</p>
            <p>格式：jpg、png</p>
          </div>
        </div>
      </div>
    </el-form-item>
  </div>
</template>

<script>
export default {
  name: 'ShareSettings',
  props: {
    // 表单数据
    value: {
      type: Object,
      required: true
    },
    // 活动数据
    activityData: {
      type: Object,
      default: () => ({
        isStart: false
      })
    },
    // 背景透明度控制（禁用状态）
    backgroundOpacity: {
      type: Boolean,
      default: false
    },
  },
  data() {
    return {
      formData: this.value,
      uploadSize: false,
      defaultSharePic: 'https://cdn-image.yucrm.cn//hd/images/13315956_98c29d9c6c2a45f5967159f05d7db917.png'
    };
  },
  watch: {
    value: {
      handler(val) {
        this.formData = val;
      },
      deep: true
    },
    formData: {
      handler(val) {
        this.$emit('input', val);
      },
      deep: true
    }
  },
  methods: {
    // 输入处理
    onInput() {
      this.$emit('input-change');
    },
    // 上传图片前校验
    onBeforeUpload(file) {
      let _this = this;
      const isSize = new Promise((resolve, reject) => {
        let width = 200;
        let height = 200;
        var _URL = window.URL || window.webkitURL;
        var img = new Image();
        img.onload = function () {
          let valid = width === this.width && height === this.height;
          valid ? resolve() : reject(this);
          _this.uploadSize = valid;
        }
        img.src = _URL.createObjectURL(file);
      }).then(() => {
        return file
      }, () => {
        this.$message.info("图片宽高不符合要求,请重新上传");
        return Promise.reject()
      })

      // 校验尺寸和类型
      const isLt1M = file.size < 1024 * 1024;
      let type = file.name.substring(file.name.lastIndexOf(".")).toLowerCase();
      let sorts = [".png", ".jpg"];
      const isType = sorts.includes(type)

      if (!isLt1M) {
        this.$message.info("上传图片大小不能超过 1MB");
      }
      if (!isType) {
        this.$message.info("所选文件格式不符，请重新选择");
      }

      return isLt1M && isType && isSize;
    },
    // 上传成功
    onUploadSuccess(res) {
      if (res.code != 1) {
        this.$message.error(res.messaga);
      } else {
        if (this.uploadSize) {
          this.formData.sharePic = res.data;
          this.$forceUpdate();
        }
      }
    },
    // 重置图片
    onPicReset() {
      this.formData.sharePic = this.defaultSharePic;
    }
  }
}
</script>

<style scoped lang="scss">
.share-settings {
  width: 100%;
}


.miniAppPic {
  position: relative;

  .image-slot {
    width: 100%;
    height: 100%;
    background: #f5f7fa;
    text-align: center;
    padding-top: 43px;

    i {
      font-size: 30px;
      color: #909399;
    }
  }

  .top {
    position: relative;
    display: flex;
    left: 0;

    .returnBtn {
      border-radius: 4px;
      width: auto;
      height: 32px;
      line-height: 32px;
      text-align: center;
      color: #2768ff;
      background: rgba(123, 97, 255, 0.1);
      border: 1px solid #2768ff;

      &:hover {
        color: #fff;
        background: #2768ff;
      }
    }

    .reset {
      color: #7b61ff;
      cursor: pointer;
      font-size: 14px;
      margin-left: 15px;

      &:hover {
        opacity: .8;
      }
    }
  }

  .noActive {
    color: #999;
    cursor: not-allowed;
  }

  .bottom {
    position: relative;
    top: 15px;

    .elImg {
      width: 120px;
      height: 120px;
      border: 1px dashed #dddddd;
      border-radius: 5px;
    }

    .tips1 {
      position: absolute;
      left: 135px;
      top: 22px;
      line-height: 2;
      color: #aaaaaa;
      font-size: 13px;
    }
  }
}


.blueText {
  color: #7b61ff;
  cursor: pointer;

  &:hover {
    opacity: .8;
  }

  &.disabled {
    color: #999 !important;
    cursor: not-allowed !important;

    &:hover {
      opacity: 1 !important;
    }
  }
}

.ml-8 {
  margin-left: 8px;
}
</style>